import client from "graphql/client";
import { loader } from "graphql.macro";
import {
    VIDEODESCRIPTIONS_SET_SINGLE,
    VIDEODESCRIPTIONS_SET_LOADING
} from "../types";

const fetchVideoDescriptionQuery = loader("../../graphql/queries/videoDescription.graphql");

export const fetchSingleVideoDescriptionAction = (videoId) => async (dispatch) => {
    dispatch({ type: VIDEODESCRIPTIONS_SET_LOADING, loading: true });

    try {
        const response = await client.query({
            query: fetchVideoDescriptionQuery,
            variables: { id: videoId },
            fetchPolicy: "network-only"
        });
        dispatch({
            type: VIDEODESCRIPTIONS_SET_SINGLE,
            videoDescription: response?.data?.adminVideoDescription || null,
        });
    } catch (error) {
        console.error("Error fetching video description:", error);
    } finally {
        dispatch({ type: VIDEODESCRIPTIONS_SET_LOADING, loading: false });
    }
};
